import { render } from "./Popup.vue?vue&type=template&id=bcc92f64"
import script from "./Popup.vue?vue&type=script&lang=ts"
export * from "./Popup.vue?vue&type=script&lang=ts"
script.render = render

export default script